import { DynamicMedia } from "@client/content/controls/Media/component";
import { type ModuleApiInfo } from "@client/content/selectors";
import CopyToClipboard from "@client/controls/CopyToClipboard/component";
import Icon from "@client/controls/Icon/component";
import Modal from "@client/controls/Modal/container";
import { type Common, IconType, type WithId } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { getVoteLink } from "../../lib";
import { type Leaderboard } from "../../types";
import Header from "../ModalHeader/container";
import Uploader from "./Uploader/component";

export type MapProps = WithId & {
  allowUploadProfilePicture: boolean;
  apiInfo: ModuleApiInfo;

  isVisible: boolean;
  item: Leaderboard.Item;
  mediaId: string | null;
  portalId: string;
};

export interface ActionProps {
  onClose: () => void;
  onProfilePictureUploaded: (media: Common.Media | null) => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <Modal
      className="cartly_content_leaderboard_vote third"
      hasBackdrop
      isAdminColor={false}
      isDraggable={false}
      isCentered
      isInViewport
      width={500}
      isLoading={false}
      isVisible={props.isVisible}
      onClose={props.onClose}
    >
      <Modal.Header>
        {({ onCloseClick }) => <Header onCloseClick={onCloseClick} id={props.id} item={props.item} />}
      </Modal.Header>
      <Modal.Body>
        {props.mediaId && (
          <div className="field">
            {/* {props.hasJoinedNow && <p className="field_label" dangerouslySetInnerHTML={{__html: i18n.whatsNext}} />} */}
            <DynamicMedia apiInfo={props.apiInfo} id={props.mediaId} />
          </div>
        )}

        {props.allowUploadProfilePicture && (
          <div className="field">
            <span className="field_label">{i18n.uploadProfilePicture}</span>
            <Uploader className="field_value" portalId={props.portalId} onUploaded={props.onProfilePictureUploaded} />
          </div>
        )}

        <div className="field">
          <span className="field_label">{i18n.voteLink}</span>
          <div className="field_value voting_link_container">
            <Icon iconClassName={IconType.Link} />
            <span className="link single-line-ellipsis">{getVoteLink(props.item.userId)}</span>
            <CopyToClipboard hideInput text={getVoteLink(props.item.userId)}>
              <Icon iconClassName={IconType.Clone} /> {i18n.copyLink}
            </CopyToClipboard>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
